<script setup lang="ts">
/** Mounted once (App.vue). Announced by screen readers: errors assertively, the rest politely. */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { dismiss, toasts } from './toast'
import Icon from './Icon.vue'

const { t } = useI18n()
const BAR = { info: 'border-s-primary', success: 'border-s-success', warning: 'border-s-warning', danger: 'border-s-danger' }
const errors = computed(() => toasts.filter((x) => x.tone === 'danger'))
const others = computed(() => toasts.filter((x) => x.tone !== 'danger'))
</script>

<template>
  <div data-toast-region class="pointer-events-none fixed bottom-4 end-4 z-toast grid w-[min(380px,calc(100vw-32px))] gap-2">
    <!-- Each toast slides in from the edge and fades out; the others close the gap (app.css, .toast-*). -->
    <TransitionGroup tag="div" name="toast" role="alert" aria-live="assertive" class="grid gap-2">
      <div v-for="x in errors" :key="x.id" :class="[BAR[x.tone], 'pointer-events-auto flex items-start gap-2 rounded-card border border-s-4 border-border bg-card px-3 py-2.5 text-[13px] shadow-pop']">
        <span class="min-w-0 flex-1">{{ x.text }}</span>
        <button type="button" class="text-muted-foreground hover:text-foreground" :aria-label="t('common.close')" @click="dismiss(x.id)">
          <Icon name="x" :size="14" />
        </button>
      </div>
    </TransitionGroup>
    <TransitionGroup tag="div" name="toast" role="status" aria-live="polite" class="grid gap-2">
      <div v-for="x in others" :key="x.id" :class="[BAR[x.tone], 'pointer-events-auto flex items-start gap-2 rounded-card border border-s-4 border-border bg-card px-3 py-2.5 text-[13px] shadow-pop']">
        <span class="min-w-0 flex-1">{{ x.text }}</span>
        <button type="button" class="text-muted-foreground hover:text-foreground" :aria-label="t('common.close')" @click="dismiss(x.id)">
          <Icon name="x" :size="14" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>
